<template>
  <section class="pa-section pa-section-terms">
    <div class="pa-golden-wide-box pa-terms">
      <p class="title">プライバシーポリシー</p>
      <div class="content pa-content">
        <PAPrivacy />
      </div>
    </div>
  </section>
</template>

<script>
import FrontPageMixins from '@/mixins/FrontPageMixins'

import PAPrivacy from '@/components/Parts/PAPrivacy/PAPrivacy.vue'

export default {
  mixins : [
    FrontPageMixins
  ],

  components: {
    PAPrivacy
  },

  async mounted(){
    await this.initializePage({
      'asLoginedView' : false
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@import "@/assets/scss/mixins.scss";
@import "@/assets/scss/globals.scss";

.pa-section{
  &-terms{
    .pa-terms{
      div.pa-content{
        font-size:1.1rem;
        padding:.5rem;

        p.update{
          text-align: right;
        }

        h4{
          margin-top:1.5rem;
        }
      }
    }
  }
}
</style>